// In sequence
export enum ViewWindow {
  OnDemand, // Optional
  Interact, // Optional
  Loader,
  Tutorial, // Optional
  Whiteboard, // Optional
  Help,
}
